import React from "react";
import Reveal from "./Reveal";
import { VALUES } from "../data/data";

export function ValueProps() {
  return (
    <section className="py-24 px-6 md:px-10">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.1}>
            <div className="flex flex-col items-start">
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-5"
                style={{ background: "rgba(225,58,48,0.12)", border: "1px solid rgba(225,58,48,0.3)" }}
              >
                <v.icon size={20} color="#1E9AFF" />
              </div>
              <h3 style={{ fontFamily: "Fraunces, serif" }} className="text-xl mb-2">{v.title}</h3>
              <p className="text-sm opacity-60 leading-relaxed">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export default ValueProps;
